import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, intlShape } from "react-intl";
import { currencyFormatterFactory } from "../utils";

export const PremiumSimulatorDeductions = (
  { benefits, deductions, provinceCode },
  { intl }
) => {
  const formatCurrency = currencyFormatterFactory(intl);
  return (
    <div className="simulationDeductions">
      <h4>
        <FormattedMessage id="clients.client.premiumSimulator.results.payrollDeductions.payrollDeductions" />
      </h4>
      <div className="summaryGroup">
        <div className="summary">
          <h5>
            <FormattedMessage id="clients.client.premiumSimulator.results.payrollDeductions.taxableBenefitsProvincial" />
          </h5>
          <dl>
            <div className="horizontalSummaryItem">
              <dt>
                <FormattedMessage id="clients.client.premiumSimulator.results.payrollDeductions.lifeInsurance" />
              </dt>
              <dd>{formatCurrency(benefits.province.life)}</dd>
            </div>

            {provinceCode == "CA-QC" && (
              <div className="horizontalSummaryItem">
                <dt>
                  <FormattedMessage id="clients.client.premiumSimulator.results.payrollDeductions.quebecHealthInsurance" />
                </dt>
                <dd>{formatCurrency(benefits.province.quebecHealth)}</dd>
              </div>
            )}
          </dl>
        </div>
        <div className="summary">
          <h5>
            <FormattedMessage id="clients.client.premiumSimulator.results.payrollDeductions.taxableBenefitsFederal" />
          </h5>
          <dl>
            <div className="horizontalSummaryItem">
              <dt>
                <FormattedMessage id="clients.client.premiumSimulator.results.payrollDeductions.lifeInsurance" />
              </dt>
              <dd>{formatCurrency(benefits.federal.life)}</dd>
            </div>
          </dl>
        </div>
        <div className="summary">
          <h5>
            <FormattedMessage id="clients.client.premiumSimulator.results.payrollDeductions.salaryDeductions" />
          </h5>
          <dl>
            <div className="horizontalSummaryItem">
              <dt>
                <FormattedMessage id="clients.client.premiumSimulator.results.payrollDeductions.groupInsurance" />
              </dt>
              <dd>{formatCurrency(deductions.premiums)}</dd>
            </div>
            {provinceCode === "CA-QC" && (
              <div className="horizontalSummaryItem">
                <dt>
                  <FormattedMessage id="clients.client.premiumSimulator.results.payrollDeductions.quebecHealthPremium" />
                </dt>
                <dd>{formatCurrency(deductions.quebecHealthPremium)}</dd>
              </div>
            )}
          </dl>
        </div>
      </div>
    </div>
  );
};

PremiumSimulatorDeductions.propTypes = {
  benefits: PropTypes.object,
  deductions: PropTypes.object,
  provinceCode: PropTypes.string,
};

PremiumSimulatorDeductions.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/premiumSimulator/results/Deductions.js